<template>
    <v-layout id="login" align-center justify-center>
        <v-flex xs12 sm8 md4>
            <Login />
        </v-flex>
    </v-layout>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/Login.vue';

export default {
    name: 'login',
    components: {
        Login,
    },
};
</script>

<style scoped lang="scss">
</style>
